/* global axios */
import ApiClient from './ApiClient';

class ReservationsAPI extends ApiClient {
  constructor() {
    super('reservations', { accountScoped: true });
  }

  listForDeal(dealId) {
    return axios.get(this.url, { params: { deal_id: dealId } });
  }

  addPayment(id, payload) {
    return axios.post(`${this.url}/${id}/add_payment`, payload);
  }

  sendReceipt(id) {
    return axios.post(`${this.url}/${id}/send_receipt`, {});
  }
}

export default new ReservationsAPI();
